import React, { useState } from 'react';
import Pagination from '@cashew/pagination';
import Box from '@cashew/box';
import List from '@cashew/list';
import Title from '@cashew/title';
import { order } from '@cashew/types';
import ListItem from '@cashew/list-item';
import cn from 'classnames';
import OrderFilter from './OrdersFilter';
import './index.css';
import { Button } from '../../../components';
import useQuery from '../../../hooks/useQuery';

const ns = 'orders';
export default ({
  t,
  useSelector,
  history,
  dispatch,
  isOffline = false,
}: any) => {
  const query = useQuery();
  const [loadingOrders, setLoadingOrders] = useState(false);
  const [list, setList] = useState<Array<order.OrderType>>([]);
  const [records, setRecords] = useState(0);
  const [showFilter, setShowFilter] = useState(false);
  const [pageNumber, setPageNumber] = useState(query.get('pageNumber') || '0');
  const [pageSize, setPageSize] = useState(
    Number.parseInt(query.get('pageSize') || '10', 10)
  );

  return (
    <div className={ns}>
      <Title>
        <span>{t('orders.title')}</span>
        <span>
          <Button
            extraClass="blue show-filter-btn"
            onClick={() => setShowFilter(!showFilter)}
          >
            <div className="btn-with-icon">
              <img src="/fillter.svg" alt="filter" />
              Filters
            </div>
          </Button>
        </span>
      </Title>
      <div className={cn({ 'hide-filter': !showFilter })}>
        <OrderFilter
          setLoading={setLoadingOrders}
          useSelector={useSelector}
          setRecords={setRecords}
          setList={setList}
          pageSize={pageSize}
          pageNumber={pageNumber}
          history={history}
          dispatch={dispatch}
          records={records}
          setPageNumber={setPageNumber}
        />
      </div>
      <div className="space-div" />
      <Box withHeader>
        <div>
          <div className={`${ns}__headers`}>
            <p>Order ID</p>
            <p>Order date</p>
            {isOffline && <p>{t('orders.table.merchantOrderCode')}</p>}
            <p>{t('orders.table.storeName')}</p>
            <p>{t('orders.table.status')}</p>
            <p>{t('orders.table.totalAmount')}</p>
          </div>
          <List
            data={list}
            component={ListItem}
            context="orders"
            isLoading={loadingOrders}
            t={t}
            isOffline={isOffline}
          />
          <Pagination
            records={records}
            pageSize={pageSize}
            pageNumber={Number.parseInt(pageNumber?.toString(), 10)}
            setPageNumber={setPageNumber}
            changePageSize={setPageSize}
          />
        </div>
      </Box>
    </div>
  );
};
